<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formProfileUser">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Permisos'" [label]="'Permisos'" [severity]="'contrast'" [icon]="'pi pi-key'"
              [disabled]="profileUserId==0" [width]="'6rem'" (onClick)="openPermissionProfile()"></app-custom-button>
            <app-custom-modal #permissionProfile [label]="textModal" [header]="textModal"
              [children]="componentPermissionProfile" [inputs$]="inputsForPermissionProfile$" [width]="'50vw'"
              hidden></app-custom-modal>

            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteProfileUser()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewProfileUser()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
      </div>
      <div class="row p-2">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-4 col-12">
              <app-custom-input-text formControlName="code" [labelText]="'Código'" [recovery]="true" [required]="true"
                (onChangeTextOnBlur)="changeProfileUser()">
              </app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true" [maxLength]="256">
              </app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-1">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>